import { render, staticRenderFns } from "./BeneficiaryBadge.vue?vue&type=template&id=e0cfe658"
import script from "./BeneficiaryBadge.vue?vue&type=script&lang=js"
export * from "./BeneficiaryBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports